import { useDeliveryApi } from 'infrastructure/api';
import {
  EngineeringBugReport,
  EngineeringIncidentReport,
  EngineeringTrackingPolicy,
  SaveBugPayload,
  SaveEngineeringConfigurationPayload,
  SaveIncidentPayload,
} from './types';

const useEngineeringService = () => {
  const { sendPostRequest, sendPutRequest } = useDeliveryApi();

  const saveConfiguration = async (
    projectId: string,
    payload: SaveEngineeringConfigurationPayload,
  ): Promise<EngineeringTrackingPolicy> => {
    const response = await sendPutRequest(`/projects/${projectId}/engineering/configuration`, payload);
    return response.json();
  };

  const confirmPpcLink = async (projectId: string): Promise<EngineeringTrackingPolicy> => {
    const response = await sendPutRequest(`/projects/${projectId}/engineering/confirm-link`);
    return response.json();
  };

  const createIncident = async (
    projectId: string,
    payload: SaveIncidentPayload,
  ): Promise<EngineeringIncidentReport> => {
    const response = await sendPostRequest(`/projects/${projectId}/engineering/incidents`, payload);
    return response.json();
  };

  const updateIncident = async (
    projectId: string,
    incidentId: string,
    payload: SaveIncidentPayload,
  ): Promise<EngineeringIncidentReport> => {
    const response = await sendPutRequest(`/projects/${projectId}/engineering/incidents/${incidentId}`, payload);
    return response.json();
  };

  const createBug = async (projectId: string, payload: SaveBugPayload): Promise<EngineeringBugReport> => {
    const response = await sendPostRequest(`/projects/${projectId}/engineering/bugs`, payload);
    return response.json();
  };

  const updateBug = async (
    projectId: string,
    bugId: string,
    payload: SaveBugPayload,
  ): Promise<EngineeringBugReport> => {
    const response = await sendPutRequest(`/projects/${projectId}/engineering/bugs/${bugId}`, payload);
    return response.json();
  };

  return {
    saveConfiguration,
    confirmPpcLink,
    createIncident,
    updateIncident,
    createBug,
    updateBug,
  };
};

export default useEngineeringService;
